"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditTask = void 0;
var _Modal = require("../../../Layout/Modal");
var _react = require("react");
var _TaskManager = require("../TaskManager.provider");
var _Button = require("../../../UI/Button");
var _EditTaskGuidelines = require("./partials/EditTaskGuidelines");
var _EditTaskName = require("./partials/EditTaskName");
var _TaskManager2 = _interopRequireDefault(require("../TaskManager.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var EditTask = function EditTask(props) {
  var isLearningActivity = props.isLearningActivity;
  var _useContext = (0, _react.useContext)(_TaskManager.TaskManagerContext),
    getLabel = _useContext.getLabel,
    setIsEditTaskDataOpened = _useContext.setIsEditTaskDataOpened,
    isEditTaskDataChanged = _useContext.isEditTaskDataChanged,
    _useContext$editTaskD = _useContext.editTaskDataName,
    editTaskDataName = _useContext$editTaskD === void 0 ? '' : _useContext$editTaskD,
    _useContext$editTaskD2 = _useContext.editTaskDataGuideLines,
    editTaskDataGuideLines = _useContext$editTaskD2 === void 0 ? '' : _useContext$editTaskD2,
    task = _useContext.task,
    setTask = _useContext.setTask,
    setIsChanged = _useContext.setIsChanged;
  var styles = (0, _TaskManager2.default)();
  var handleBack = function handleBack() {
    setIsEditTaskDataOpened(false);
  };
  var handleSave = function handleSave() {
    if (!(task !== null && task !== void 0 && task.isReadOnly) && isEditTaskDataChanged && /\S/.test(editTaskDataName) && (/\S/.test(editTaskDataGuideLines) || isLearningActivity)) {
      setTask(_objectSpread(_objectSpread({}, task), {}, {
        name: editTaskDataName,
        guideLines: editTaskDataGuideLines
      }));
      setIsEditTaskDataOpened(false);
      setIsChanged(true);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-TaskManager__full-item'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
      title: getLabel('edit_task_title')
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal.Content, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_EditTaskName.EditTaskName, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditTaskGuidelines.EditTaskGuidelines, {})]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal.Footer, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          view: "link",
          onClick: handleBack,
          children: getLabel('back')
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          view: "contained",
          color: "primary",
          onClick: handleSave,
          isDisabled: !(isEditTaskDataChanged && /\S/.test(editTaskDataName) && (/\S/.test(editTaskDataGuideLines) || isLearningActivity)),
          children: getLabel('save')
        })
      })]
    })]
  });
};
exports.EditTask = EditTask;